import styled from "styled-components";

import { useMainStore } from "../store/mainStore";
import { DESKTOP_BREAKPOINT } from "../styles/breakpoints";
import { Body } from "../styles/stringStyles";
import { hexWithOpacity } from "../utils/hexWithOpacity";
import { CustomButton } from "./buttons/CustomButton";

export const VersionTag = ({ displayMobile }: { displayMobile?: boolean }) => {
  const setEventIndicator = useMainStore(
    (state) => state.setEventIndicatorData
  );
  const copyToClipboard = () => {
    try {
      navigator.clipboard.writeText(import.meta.env.VITE_VERSION);
      setEventIndicator("success", "In die Zwischenablage kopiert");
    } catch (error) {
      console.error("Failed to copy to clipboard", error);
      setEventIndicator("error", "Fehler beim Kopieren");
    }
  };

  const version = import.meta.env.VITE_VERSION;
  return (
    <Container $displayMobile={displayMobile}>
      <CustomButton onClick={copyToClipboard}>
        <StyledBody>{"v" + version}</StyledBody>
      </CustomButton>
    </Container>
  );
};

const Container = styled.div<{ $displayMobile?: boolean }>`
  z-index: 3;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 30px;
  @media (max-width: ${DESKTOP_BREAKPOINT}) {
    position: relative;
    display: ${({ $displayMobile }) => ($displayMobile ? "flex" : "none")};
    align-items: center;
    justify-content: center;
    width: 100%;
  }
`;

const StyledBody = styled(Body)`
  color: ${({ theme }) => hexWithOpacity(theme.colors.medium, 0.5)};
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 1;
  }
  &:active {
    opacity: 0.1;
  }
  @media (max-width: ${DESKTOP_BREAKPOINT}) {
    opacity: 0.5;
  }
`;
